<template>
  <v-container>
    <v-row>
      <v-col md="5" class="d-flex align-center">
        <v-img
          :src="require('@/assets/images/register_image.png')"
          class="ma-8"
          width="400"
        />
      </v-col>
      <v-col md="7" v-if="step === 'register'" class="d-flex align-center">
        <div class="flex-fill">
          <h1 class="text-center">ثبت نام</h1>
          <p class="text-center">برای ثبت نام اطلاعات کاربری را وارد نمایید</p>
          <v-card outlined class="pa-5">
            <form-alert
              v-if="this.$store.getters.error"
              :message="this.$store.getters.error.message.message"
            />
            <v-form
              v-model="valid"
              @submit.prevent="handleSignupUser"
              class="text-center"
            >
              <v-text-field
                outlined
                dense
                name="username"
                v-model="username"
                :rules="usernameRules"
                autocomplete="off"
                type="number"
                label="تلفن همراه"
                required
              />
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="firstname"
                    :rules="firstnameRules"
                    autocomplete="off"
                    label="نام"
                    required
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="lastname"
                    :rules="lastnameRules"
                    autocomplete="off"
                    label="نام خانوادگی"
                    required
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    outlined
                    dense
                    :items="stateItems"
                    v-model="state"
                    :rules="stateRules"
                    item-text="name"
                    item-value="_id"
                    label="استان"
                    required
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    outlined
                    dense
                    :items="cityItems"
                    v-model="city"
                    :rules="cityRules"
                    item-text="name"
                    item-value="_id"
                    label="شهر"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    dense
                    v-model="school"
                    :rules="schoolRules"
                    autocomplete="off"
                    label="نام مدرسه"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <p class="text-center">کلمه عبور برای خود ایجاد کنید</p>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="password"
                    label="انتخاب کلمه عبور"
                    :rules="passwordRules"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    autocomplete="off"
                    hint="پسورد می بایست حداقل از 6 حرف تشکیل شده باشد"
                    counter
                    required
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="confirmPass"
                    label="تکرار کلمه عبور"
                    :rules="confirmPassRules.concat(passwordConfirmationRule)"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                    autocomplete="off"
                    hint="پسورد می بایست حداقل از 6 حرف تشکیل شده باشد"
                    counter
                    required
                  />
                </v-col>
              </v-row>
              <div class="d-flex mt-2">
                <v-btn
                  :loading="loading"
                  :disabled="!valid || loading"
                  depressed
                  color="primary"
                  type="submit"
                  class="flex-grow-1"
                >
                  ثبت نام
                </v-btn>
                <v-btn
                  color="success"
                  depressed
                  outlined
                  class="mr-2"
                  router
                  to="Login"
                >
                  قبلا ثبت‌نام کرده‌اید؟
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </div>
      </v-col>
      <v-col md="7" v-if="step === 'verifyOTP'" class="d-flex align-center">
        <div class="flex-fill">
          <h1 class="text-center">تایید شماره همراه</h1>
          <p class="text-center">
            کد ارسالی به شماره موبایل خود را وارد نمایید
          </p>
          <v-card outlined class="pa-5">
            <div v-if="this.$store.getters.error">
              <div
                v-for="(item, key, index) in this.$store.getters.error"
                :key="index"
              >
                <form-alert v-if="item" :message="item" />
              </div>
            </div>
            <v-form
              v-model="valid"
              @submit.prevent="handleActiveUser"
              class="text-center"
            >
              <v-text-field
                outlined
                dense
                v-model="activeCode"
                :rules="activeCodeRules"
                autocomplete="off"
                label="کد تایید"
                required
              />
              <div class="d-flex align-center">
                <v-btn
                  :loading="loading"
                  :disabled="!valid || loading"
                  depressed
                  color="primary"
                  type="submit"
                  class="flex-grow-1"
                >
                  ثبت نام
                </v-btn>
                <v-btn
                  :loading="loading"
                  :disabled="counting"
                  @click="resendOtp"
                  depressed
                  outlined
                  color="success"
                  class="mr-2"
                >
                  <countdown
                    v-if="counting"
                    :time="120000"
                    @end="handleCountdownEnd"
                  >
                    <template slot-scope="props">
                      ارسال مجدد {{ props.totalSeconds }}
                    </template>
                  </countdown>
                  <span v-else> ارسال مجدد </span>
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn class="mt-2" router to="/" text> بازگشت </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "signup-component",
  data: () => {
    return {
      isFormValid: true,
      loading: false,
      valid: true,
      show1: false,
      show2: false,
      counting: true,
      step: "register",
      errors: [],
      firstname: "",
      firstnameRules: [(v) => !!v || "نام خود را وارد نمایید"],
      lastname: "",
      lastnameRules: [(v) => !!v || "نام خانوادگی خود را وارد نمایید"],
      username: "",
      usernameRules: [
        (v) => !!v || "لطفا تلفن همراه خود را وارد نمایید",
        (v) => (v && v.length == 11) || "تلفن همراه را به درستی وارد نمایید"
      ],
      state: "",
      stateRules: [(v) => !!v || "استان خود را انتخاب نمایید"],
      stateItems: [],
      city: "",
      cityRules: [(v) => !!v || "شهر خود را انتخاب نمایید"],
      cityItems: [],
      school: "",
      schoolRules: [(v) => !!v || "نام مدرسه خود را انتخاب نمایید"],
      password: "",
      passwordRules: [(v) => !!v || "کلمه عبور خود را وارد نمایید"],
      confirmPass: "",
      confirmPassRules: [(v) => !!v || "تکرار کلمه عبور خود را وارد نمایید"],
      activeCode: "",
      activeCodeRules: [
        (v) => !!v || "کد ارسالی را وارد نمایید",
        (v) =>
          (v && v.length == 6) || "کد ارسالی را با دقت و به درستی وارد نمایید"
      ]
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () => this.password === this.confirmPass || "پسور یکسان نیست";
    }
  },
  watch: {
    state(val) {
      this.city = "";
      this.handleGetCity(val);
    }
  },
  created() {
    this.handleGetStates();
  },
  methods: {
    handleSignupUser() {
      this.loading = true;
      this.$api
        .post("user/exists", { mobilenumber: this.username })
        .then(() => {
          this.$store
            .dispatch("signupUser", {
              username: this.username,
              firstname: this.firstname,
              lastname: this.lastname,
              password: this.password,
              city: this.city,
              school: this.school,
              type: "دانش آموز"
            })
            .then(() => {
              this.step = "verifyOTP";
              this.loading = false;
            });
        })
        .catch((err) => {
          const status = err.response.status;
          if (status == 406) {
            this.$store.commit("setMessageState");
            this.$store.commit("setMessageType", "error");
            this.$store.commit("setMessage", err.response.data.message);
          }
          this.loading = false;
        });
    },
    handleActiveUser() {
      this.loading = true;
      this.$store.dispatch("activeUser", {
        username: this.username,
        activeCode: this.activeCode
      });
      this.loading = false;
    },
    handleGetStates() {
      this.loading = true;
      this.$api.get("/states").then((res) => {
        const states = res.data.states;
        states.forEach((element) => {
          this.stateItems.push(element);
        });
        this.loading = false;
      });
    },
    handleGetCity(id) {
      this.loading = true;
      this.cityItems = [];
      this.$api.get("/cities/" + id).then((res) => {
        const cities = res.data.cities;
        cities.forEach((element) => {
          this.cityItems.push(element);
        });
        this.loading = false;
      });
    },
    resendOtp() {
      this.$api
        .post("user/resendOTP", {
          username: this.username
        })
        .then(() => {
          this.counting = true;
        });
    },
    handleCountdownEnd() {
      this.counting = false;
    }
  }
};
</script>
